module.exports = __webpack_public_path__ + "static/media/homePlate3Bg.7f2e180c.png";